export default __webpack_public_path__ + "static/media/lock.31708f63.svg";